import React from "react";
import { TCustomizationSelection } from "constants/product-customizations/customization-selection.types";
import { CustomizationTitleView } from "./customization-title-view";
import { CustomizationViewContent } from "./customization-view-content";

interface IProps {
    customization: TCustomizationSelection;
}

export const CustomizationView: React.FC<IProps> = ({ customization }) => {
    return (
        <CustomizationTitleView label={customization.label}>
            {<CustomizationViewContent customization={customization} />}
        </CustomizationTitleView>
    );
};
